import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatatableComponent } from './datatable.component';
import { GroupedCheckboxModule } from '../grouped-checkbox/index';
import { ArrayFilterModule } from '../pipe/array-filter.module';
import { MyDatepickerModule } from '../datepicker/datepicker.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        GroupedCheckboxModule,
        ArrayFilterModule,
        MyDatepickerModule
    ],
    declarations: [DatatableComponent],
    exports: [DatatableComponent],
    providers: []
})

export class DatatableModule { }
